import script from "./CustomResourceApplySPHZB.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomResourceApplySPHZB.vue?vue&type=script&setup=true&lang=ts"

import "./CustomResourceApplySPHZB.vue?vue&type=style&index=0&id=47f3f2bb&lang=less&scope=true"

const __exports__ = script;

export default __exports__